module.exports = __webpack_public_path__ + "img/background.e55436dc.png";